<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <a-input v-decorator="['itemCode']" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料类型" :help="null">
              <global-select
                v-decorator="['itemType', { rules: [{ required: true }], initialValue: ['YL'] }]"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'MDM_ITEM_TYPE' }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="规格描述">
              <a-input v-decorator="['specification']" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="备料分类">
              <global-select
                v-decorator="['deliveryType']"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'MDM_DELIVERY_TYPE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiMdmItemMaintenanceNewExport" ref="download" />
      <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['mdm:mdmItemMaintenance:materialsImport']">导入</a-button>
      <a-button @click="handleExport" type="primary" v-hasPermi="['mdm:mdmItemMaintenance:materialsExport']">导出</a-button>
      <a-button @click="handleSpecializedUseRefresh" type="primary" v-hasPermi="['mdm:mdmItemMaintenance:refreshSpecializedUse']" :loading="btnLoadingObj.isSpecializedUseRefreshBtnLoading">专共用刷新</a-button>
      <!-- <a-button @click="importTemplate">下载模板</a-button> -->
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1600 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MATERIAL_PROPERTY_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['mdm:mdmItemMaintenance:materialsEdit']">编辑</a>
                <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.type === 'select'">
                <span v-if="!isEdit || currentId !== record.id">{{ item.showDataIndex ? meaning(record, item.showDataIndex) : meaning(record, item.dataIndex) }}</span>
                <global-select
                  v-if="isEdit && currentId === record.id"
                  :value.sync="record[item.dataIndex]"
                  :selectType="item.selectType ? item.selectType : 'select'"
                  :requestApi="item.requestApi"
                  :selectData="setArray(item.dataList)"
                  :selectItem="{ value: item.value, label: item.label }"
                  :searchParam="item.searchParam ? item.searchParam : ''"
                  :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
                  :allowClear="false"
                  size="small"
                  :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
                  :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
                  @change="selectChange(item.dataIndex, record)"
                />
              </span>
              <span v-else-if="item.type === 'inputNumber'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" :min="0" size="small" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </div>
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @ok="importExcelHandleCancel"
        @cancel="importExcelHandleCancel"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiMdmItemMaintenanceMaterialsEdit, apiMdmItemMaintenanceMaterialsList, apiMdmItemMaintenanceNewExport, apiMdmItemMaintenanceMaterialsRefreshSpecializedUse } from '@/api/mdm/matter/raw-material-property'
import Cookies from 'js-cookie';
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'Raw-material-property',
  components: { DownloadModal },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
       apiMdmItemMaintenanceNewExport,
       // 表格配置
       tableProps: {
        requestApi: generateLsTableResData(apiMdmItemMaintenanceMaterialsList, true),
        pageCurrent: true
      },
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/mdm/mdmItemMaintenance/materialsImport'
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      form: this.$form.createForm(this),
      // 表格字段
      columns: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '物料类型',
          dataIndex: 'itemType',
          align: 'center'
        },
        {
          title: '采购提前期',
          dataIndex: 'purchasingLeadTime',
          scopedSlots: { customRender: 'purchasingLeadTime' },
          align: 'center',
          type: "inputNumber"
        },
        {
          title: '备库提前期',
          dataIndex: 'safetyStockLeadTime',
          scopedSlots: { customRender: 'safetyStockLeadTime' },
          align: 'center',
          type: "inputNumber"
        },
        {
          title: '最小包装',
          dataIndex: 'fixedLotMultiplier',
          scopedSlots: { customRender: 'fixedLotMultiplier' },
          align: 'center',
          type: "inputNumber"
        },
        {
          title: '备料分类',
          dataIndex: 'deliveryTypeCode',
          showDataIndex: 'deliveryType',
          scopedSlots: { customRender: 'deliveryTypeCode' },
          align: 'center',
          width: 150,
          type: "select",
          requestApi: "/system/lookup/data/list",
          value: 'lookupCode',
          label: 'lookupValue',
          setParams: true
        },
        {
          title: '专共用',
          dataIndex: 'specializedUse',
          scopedSlots: { customRender: 'specializedUse' },
          width: 120,
          align: 'center',
          type: "select",
          requestApi: "/system/lookup/data/list",
          value: 'lookupCode',
          label: 'lookupValue',
          setParams: true
        },
        {
          title: 'ABC分类',
          dataIndex: 'abcClassification',
          scopedSlots: { customRender: 'abcClassification' },
          width: 120,
          align: 'center',
          type: "select",
          requestApi: "/system/lookup/data/list",
          value: 'lookupCode',
          label: 'lookupValue',
          setParams: true
        },
        {
          title: '一级分类',
          dataIndex: 'name1',
          align: 'center'
        },
        {
          title: '二级分类',
          dataIndex: 'name2',
          align: 'center'
        },
        {
          title: '三级分类',
          dataIndex: 'name3',
          align: 'center'
        },
        {
          title: '最后修改人',
          dataIndex: 'name',
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          align: 'center',
          width: 170,
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      btnLoadingObj: {
        // 专共用刷新按钮loading状态
        isSpecializedUseRefreshBtnLoading: false
      }
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {},
  mounted () {
    this.handleQuery()
  },
  methods: {
    // 表单搜索
    onSearch () {
      if (this.form.getFieldsValue().itemType.length === 0) {
        this.$message.warning('物料类型不能为空')
        return false
      }
      this.$refs.dataTable.searchParams = { ...this.form.getFieldsValue(), organizationCode: this.organizationCodeOrigin };
      this.$refs.dataTable.getData();
      this.isEdit = false
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }

      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      // if (record.purchasingLeadTime === 0) {
      //   this.$message.warning("采购提前期需大于0")
      //   return
      // }
      // if (record.safetyStockLeadTime === 0) {
      //   this.$message.warning("备库提前期需大于0")
      //   return
      // }
      // if (record.fixedLotMultiplier === 0) {
      //   this.$message.warning("最小包装需大于0")
      //   return
      // }
      record.deliveryType = record.deliveryTypeCode
      delete record.deliveryTypeCode
      apiMdmItemMaintenanceMaterialsEdit(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.handleQuery()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.handleQuery()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.handleQuery()
    },
    meaning (record, dataIndex) {
      return record[dataIndex]
    },
    selectChange (val, record) {},
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "deliveryTypeCode") {
        return { lookupType: 'MDM_DELIVERY_TYPE' }
      }
      if (dataIndex === "specializedUse") {
        return { lookupType: 'MDM_SPECIALIZED_USE' }
      }
      if (dataIndex === "abcClassification") {
        return { lookupType: 'MDM_ABC_CLASSIFICATION' }
      }
    },
    setArray (arr) {
      return this[arr]
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('mdm/mdmItemMaintenance/materialsTemplate', {
        ...this.form.getFieldsValue()
      }, `原材料属性维护导入模板_${new Date().getTime()}.xlsx`)
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = { ...this.form.getFieldsValue(), organizationCode: this.organizationCodeOrigin }
      this.$refs.download.openModal(params)
      // this.download('mdm/mdmItemMaintenance/materialsExport', {
      //   ...this.form.getFieldsValue()
      // }, `原材料属性维护_${new Date().getTime()}.xlsx`)
    },
    handleSpecializedUseRefresh () {
      this.btnLoadingObj.isSpecializedUseRefreshBtnLoading = true
      apiMdmItemMaintenanceMaterialsRefreshSpecializedUse().then(res => {
        if (res.code === 200) {
          this.$message.success('刷新成功')
          this.handleQuery()
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.btnLoadingObj.isSpecializedUseRefreshBtnLoading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.page-header-content{
  /deep/.ant-select{
    width: 100%;
  }
  /deep/.ant-input-number {
    width: 100%;
  }
}
</style>
